import React from "react";

// TODO(client): confirm contact email. The original CRA site uses three real lodge
// gmail addresses (secretaryraf9456@gmail.com, raflodge@gmail.com,
// treasurerraf9456@gmail.com); they are kept here so the live mailto links continue
// to work. Swap to a single secretary alias if the lodge prefers one inbox.
const SECRETARY_EMAIL = "secretaryraf9456@gmail.com";
const MASTER_EMAIL = "raflodge@gmail.com";
const TREASURER_EMAIL = "treasurerraf9456@gmail.com";

const DARK_CARD_STYLE = {
  background: "rgba(247, 242, 231, 0.06)",
  borderColor: "rgba(247, 242, 231, 0.15)",
  color: "var(--paper)",
};

function ContactRow({ label, email }) {
  return (
    <div
      style={{
        borderTop: "1px solid rgba(247, 242, 231, 0.15)",
        padding: "18px 0 6px",
      }}
    >
      <p
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: "0.72rem",
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "#e9c97a",
          margin: "0 0 6px",
          fontWeight: 600,
        }}
      >
        {label}
      </p>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "grid",
          gap: 4,
          fontSize: "1.02rem",
        }}
      >
        <li>
          <a href={`mailto:${email}`}>{email}</a>
        </li>
      </ul>
    </div>
  );
}

function Contact() {
  return (
    <section id="contact" className="section section--ink">
      <div className="container">
        <div style={{ maxWidth: "68ch" }}>
          <p className="eyebrow">Get in touch</p>
          <h2>Drop us a line.</h2>
          <p className="lede" style={{ color: "var(--paper-2)" }}>
            Whether you're a Mason wishing to visit, or simply curious about
            Freemasonry, we'd be delighted to hear from you. Visitors are always welcome
            at the Knowle Masonic Centre.
          </p>
        </div>

        <div className="contact-grid">
          <div>
            <div className="contact-card" style={DARK_CARD_STYLE}>
              <h3 style={{ color: "var(--paper)" }}>Where to find us</h3>
              <dl>
                <dt>Meeting address</dt>
                <dd>1621 Warwick Road, Knowle, Solihull B93 9LF, United Kingdom</dd>
                <dt>Correspondence</dt>
                <dd>
                  Please write to us c/o the Lodge Secretary &mdash; email below for the
                  current postal address.
                </dd>
              </dl>
            </div>

            <iframe
              title="Knowle Masonic Centre on Google Maps"
              className="map-frame"
              style={{ marginTop: 24 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.8577844743486!2d-1.7402590227370933!3d52.39112837202768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870b7a7f43baedd%3A0xb053ca937a870d41!2sKnowle%20Masonic%20Centre!5e0!3m2!1sen!2suk!4v1723994040732!5m2!1sen!2suk"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div>
            <div className="contact-card" style={DARK_CARD_STYLE}>
              <h3 style={{ color: "var(--paper)" }}>Speak to us directly</h3>
              <p style={{ color: "var(--paper-2)", marginTop: 0 }}>
                The simplest way to start is a friendly email or phone call &mdash; no
                forms, no obligation.
              </p>
              <ContactRow label="Lodge Secretary" email={SECRETARY_EMAIL} />
              <ContactRow label="Worshipful Master" email={MASTER_EMAIL} />
              <ContactRow label="Lodge Treasurer" email={TREASURER_EMAIL} />
              <a
                className="btn"
                href={`mailto:${SECRETARY_EMAIL}`}
                style={{ marginTop: 18 }}
              >
                Email the Lodge Secretary{" "}
                <span className="arrow" aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
